module.exports = __webpack_public_path__ + "static/media/Wolverine.4bbbc2f8.jpg";